import { assign, getElement } from "./common";
import UploaderModel from "./UploaderModel";
import UploaderView from "./UploaderView";
import ExtendableObject from "./ExtendableObject";
import BasicAdapter from "./BasicAdapter";

const Uploader = ExtendableObject.extend(
  /** @lends Uploader.prototype */
  {
    /**
     * Manages a model + view pair
     * @constructs
     * @extends ExtendableObject
     * @param {object} opts - options inherited by all composed objects
     */
    constructor(opts) {
      /**
       * @protected
       * @type {object}
       */
      this.opts = assign({}, this.getDefaultOptions(), opts);

      const templateEl = getElement(this.opts.template);
      if(!templateEl) throw new Error("Uploader: template must be an element or a valid id");

      this.opts.template = new VOID.Template();
      this.opts.template.addTemplate("base", templateEl.innerHTML);

      this.opts.adapter = this.createAdapter();

      /**
       * @type {UploaderModel}
       */
      this.model = this.createModel();

      this.populateModelFromHTML();

      /**
       * @type {UploaderView}
       */
      this.view = this.createView();
    },

    /**
     * Factory method creating an uploader model
     * @protected
     * @returns {UploaderModel}
     */
    createModel() {
      return new UploaderModel(this.opts);
    },


    /**
     * Factory method creating an uploader view
     * @protected
     * @returns {UploaderView}
     */
    createView() {
      return new UploaderView(this.model, this.opts);
    },

    /**
     * Factory method for creating an upload adapter
     * @protected
     * @returns {UploadAdapter}
     */
    createAdapter() {
      return new BasicAdapter(this.opts);
    },

    /**
     * Default options factory
     * @protected
     * @returns {object}
     */
    getDefaultOptions() {
      return {};
    },

    populateModelFromHTML() {
      const els = getElement(this.opts.el).children;
      const files = [];
      for(let i = 0; i < els.length; i++) {
        const el = els[i];
        if(el.nodeType === Node.ELEMENT_NODE && el.hasAttribute("data-uploader-id")) {
          const file = {};

          for (let j = 0; j < el.attributes.length; j++) {
            const {name, value} = el.attributes[j];
            const match = /^data-uploader-(.+)$/.exec(name);
            if (match) file[match[1]] = value;
          }

          file.width = +file.width;
          file.height = +file.height;
          file.fullWidth = +file.fullWidth;
          file.fullHeight = +file.fullHeight;
          try {
            file.data = JSON.parse(file.data || "null");
          } catch(e) {
            console.error(e);
          }
          files.push(file);
        }
      }
      this.model.addFiles(files, true);
    }
  });

export default Uploader;
